import { waitForBoolean } from './common';
import { MagpieConnection } from 'magpie-lib/connection';
export const waitForConnectedMagpie = async () => {
  const isConnected = await waitForBoolean(() => {
    try {
      return !!MagpieConnection.get().getClientId();
    } catch (e) {
      return false;
    }
  });
  if (!isConnected) {
    throw new Error('Magpie is not connected');
  }
  return;
};